import {KeyState} from '../../../shared/interfaces';

class KeyStateManager {

    data: KeyState
    changed: boolean;
    spaceUpEvent: () => void;
    spaceDownEvent: () => void;
    enterUpEvent: () => void;
    enabled: boolean;

    constructor() {

        this.data = {
            ctrl: false,
            shift: false,
            left: false,
            right: false,
            up: false,
            down: false
        }
        this.changed = false;
        this.enabled = true;

        document.onkeydown = event => {
            if(this.enabled) {
                switch(event.keyCode) {
                    case 16:
                        this.data.shift = true
                        break
                    case 17:
                        this.data.ctrl = true
                        break
                    case 65:
                    case 37:
                        this.data.left = true
                        break
                    case 87:
                    case 38:
                        this.data.up = true
                        break
                    case 68:
                    case 39:
                        this.data.right = true
                        break
                    case 40:
                    case 83:
                        this.data.down = true
                        break
                    case 32:
                        this.spaceDownEvent();
                        break;
                    default:
                        break
                }
                this.changed = true;
            }
        };

        document.onkeyup = event => {
            if(this.enabled) {
                switch(event.keyCode) {
                    case 16:
                        this.data.shift = false
                        break
                    case 17:
                        this.data.ctrl = false
                        break
                    case 65:
                    case 37:
                        this.data.left = false
                        break
                    case 87:
                    case 38:
                        this.data.up = false
                        break
                    case 68:
                    case 39:
                        this.data.right = false
                        break
                    case 40:
                    case 83:
                        this.data.down = false
                        break
                    case 32:
                        this.spaceUpEvent();
                        break;
                    case 13:
                        this.enterUpEvent();
                        break;
                    default:
                        break
                }
                this.changed = true;
            }
        }
    }

    shift() {
        return this.data.shift;
    }

    ctrl() {
        return this.data.ctrl;
    }

    left() {
        return this.data.left;
    }

    right() {
        return this.data.right;
    }

    up() {
        return this.data.up;
    }

    down() {
        return this.data.down;
    }

    hasChanged() {
        return this.changed;
    }

    setEnabled(value:boolean) {
        this.enabled = value;
    }

    getFullState() {
        this.changed = false;
        return this.data;
    }
}

export default new KeyStateManager();
